export default "__VITE_ASSET__CmsHtjOC__"